import { render, staticRenderFns } from "./BoWineriesLogo.vue?vue&type=template&id=d4426d74&"
import script from "./BoWineriesLogo.vue?vue&type=script&lang=js&"
export * from "./BoWineriesLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports